var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedTime(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00244141,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#4F66AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9976 12.6V19.8H19.3976V17.4H6.59756V19.8H4.99756V7H6.59756V15H12.9976V9.4H17.7976C18.6463 9.4 19.4602 9.73714 20.0603 10.3373C20.6604 10.9374 20.9976 11.7513 20.9976 12.6ZM9.79756 14.2C9.16104 14.2 8.55059 13.9471 8.1005 13.4971C7.65042 13.047 7.39756 12.4365 7.39756 11.8C7.39756 11.1635 7.65042 10.553 8.1005 10.1029C8.55059 9.65286 9.16104 9.4 9.79756 9.4C10.4341 9.4 11.0445 9.65286 11.4946 10.1029C11.9447 10.553 12.1976 11.1635 12.1976 11.8C12.1976 12.4365 11.9447 13.047 11.4946 13.4971C11.0445 13.9471 10.4341 14.2 9.79756 14.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedTime);
export default __webpack_public_path__ + "static/media/bed-time.ee53eef4205a08ee631832fbb2173162.svg";
export { ForwardRef as ReactComponent };